import React from 'react'
import './Aboutme.css'

function Aboutme() {
  return (
    <div className='aboutme'>
        <div className='aboutme__left'>
            <h1>About Me</h1>
            <span> Hello,I am a full-stack Engineer with all skills in Reactjs, React Native,<br/> and NodeJS.
                    I use React for Front-End projects and NodeJS for<br/> Backend including APIs.I have built a fully functional portfolio <br/>with my recent work with links.
                    I have others hosted on amazon's <br/>AWS and others hosted with Google's Firebase .It includes full-stack<br/>  projects that are clones and others for my practice.
                    This will let you<br/>  know all the skills am equipped with while tackling your work.After <br/> completing my Diploma in ICT I began teaching myself Development <br/> starting 
                    with Python, Python Django, React, React Native, and<br/>  previously Nodejs. I have majored in javascript framework React for <br/> web apps and react native for mobile apps.
                    I use Nodejs to create <br/> API sockets,  MongoDB,  Firestore DB, and AWS serverless MongoDB <br/> among others to create a full-functioning Backend for my projects.<br/>  If you hire me,
                    you have hired the necessary skills you need for your job.<br/>  Looking forward to working with you.<br/>
            </span>
        </div>
        <div className='aboutme__right'>
            <h1>content</h1>
            <span></span>
        </div>
        
    </div>
  )
}

export default Aboutme